import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img4 from "../../About/images/4.jpg";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person4 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img4} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Андрашко Юрий Васильевич
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Applied mathematics, Master of Applied mathematics, PhD in engineering (Information technologies)
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57194702818'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0003-2306-8377'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        Ужгородский национальный университет, г. Ужгород, Украина, доцент кафедры системного анализа и теории оптимизации<br/>
                        <b>Стаж по профилю – 12 лет.</b>
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Научный сотрудник.<br />
                    - Совместное проведение экспериментальных исследований;<br />
                    - написание научных статей;<br />
                    - Разработка моделей прогнозирования загрязняющих веществ в окружающую среду от основных стационарных источников эмиссий для разных групп предприятий<br />
                    - Создание методов расчета прогнозирования выбросам, подлежащих к непрерывному мониторингу
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Участие в проекте обусловлено высокой профессиональной квалификацией и значительным практическим опытом в сфере прикладной математики и информационных технологий. Опыт, научная компетентность и практические навыки участника позволяют обеспечивать высокий уровень выполнения научно-исследовательских задач, что делает его участие в проекте обоснованным и критически важным для достижения поставленных целей.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные Проекты, в которых принимал участие:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    • Исполнитель проекта грантового финансирования, (AP23490123) «Разработка системы идентификации текстовых заимствований на основе комбинированных методов и моделей поиска неполных дубликатов с учетом казахского языка» (2024 -2026 г.).
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    • Исполнитель проекта грантового финансирования, (AP19678730) «Разработка информационной технологии точного земледелия для управления сельскохозяйственной деятельностью с применением «Internet of Things» (2023-2025 г.).
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    • Исполнитель проекта грантового финансирования, (AP19678627) «Разработка информационной технологии, формирования мультиуниверситетских научных и образовательных сообществ, основанной на теории наукометрического анализа» (2023 -2025 г.).
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    • Исполнитель проекта грантового финансирования, (AP13067967) «Разработка технологии построения микропроцессорных ресурсосберегающих устройств релейной защиты на основе открытой архитектуры» (2022-2024 г.).
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    • Исполнитель фундаментального исследования, (0122U000937) "Identification and determination of physical parameters of space objects in the interests of defense capability and national security of Ukraine", Украина (2022-2024 г.)
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    • Исполнитель проекта по программе "Программно-целевое финансирование по научным, научно-техническим программам" Комитета науки Министерства науки и высшего образования Республики Казахстан, (BR10965311) Разработка интеллектуальных информационно-телекоммуникационных систем для городской инфраструктуры: транспорт, экология, энергетика и аналитика данных в концепте Smart City (2021-2023 г.)
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    • Исполнитель проекта грантового финансирования, (AP08857218) «Информационная технология оценивания научной деятельности вузов, НИИ и их подразделений» (2020-2022 г.).
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в достижении результатов проекта:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - совместное проведение экспериментальных исследований, написание научных статей;<br/>
                    - создание моделей облачной архитектуры программного комплекса, реализованного с использованием технологии микросервисов.<br/>
                    - Разработка моделей прогнозирования загрязняющих веществ в окружающую среду от основных стационарных источников эмиссий для разных групп предприятий<br/>
                    - Создание методов расчета прогнозирования выбросам, подлежащих к непрерывному мониторингу<br/>
                    - проведение исследований и создание методов и моделей прогнозирования временных рядов выбросов загрязняющих веществ и выпусков сточных вод для задачи экологического мониторинга
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Публикации по теме проекта:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Biloshchytskyi A.; Kuchanskyi O.; Neftissov A.; Andrashko Y.; Biloshchytska S.; Kazambayev, I. (2024). Fractal Analysis of Mining Wastewater Time Series Parameters: Balkhash Urban Region and Sayak Ore District. Urban Science. DOI 10.3390/urbansci8040200 (SCOPUS, Q1).
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    2. Biloshchytskyi, A.; Neftissov, A.; Kuchanskyi, O.; Andrashko, Y.; Biloshchytska, S.; Mukhatayev, A.; Kazambayev, I. (2024). Fractal Analysis of Air Pollution Time Series in Urban Areas in Astana, Republic of Kazakhstan. Urban Science. DOI 10.3390/urbansci8030131 (SCOPUS, Q1).
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    3. Biloshchytskyi, A., Kuchansky, A., Andrashko, Y., Neftissov, A., Vatskel, V., Yedilkhan, D., Herych, M. Building a model for choosing a strategy for reducing air pollution based on data predictive analysis. (2022) Eastern-European Journal of Enterprise Technologies, 3 (4-117), pp. 23-30. DOI: 10.15587/1729-4061.2022.259323 (SCOPUS, Q3).
                </MyText>
            </Flex>
        </Flex>
    );
}